'use client';
import Image from 'next/image';
import ModalForm from '../Modal/Modal';
import { ReactNode, useState } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

export interface AuPairBlockProps {
  id?: string;
  title?: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  image?: string | { url: string; alt: string };
  imageWidth?: number;
  imageHeight?: number;
  formatList?: Array<{
    icon?: string;
    title: ReactNode | SerializedEditorState;
  }>;
  btnText?: string;
  color: 'blue' | 'green' | 'violet';
}

export default function AuPairBlock({
  id,
  title,
  subtitle,
  image,
  imageWidth,
  imageHeight,
  formatList,
  btnText,
  color = 'blue',
}: AuPairBlockProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  return (
    <>
      <div
        id={id}
        data-meta="AuPairBlock"
        className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-14"
      >
        <div className="flex flex-col xl:flex-row xl:gap-12">
          <div className="flex flex-col justify-start order-1 xl:order-2">
            <CustomRichText
              data={title}
              tag="h2"
              className="text-3xl font-bold tracking-tight text-white sm:text-6xl mb-4 sm:mb-8"
            />
            <CustomRichText
              data={subtitle}
              tag="div"
              className="mt-2 text-md lg:text-xl lg:leading-8 text-white"
            />
          </div>
          {image && (
            <div className="flex flex-col justify-center lg:flex-row xl:flex-col order-2 xl:order-1">
              <Image
                src={typeof image === 'string' ? image : image.url}
                alt={typeof image === 'string' ? '' : image.alt}
                width={imageWidth || 550}
                height={imageHeight || 100}
              />
            </div>
          )}
        </div>
        <div className="flex flex-col lg:flex-row lg:flex-wrap mt-2 lg:mt-8  gap-2 lg:gap-8">
          {formatList &&
            formatList.map((item, index) => (
              <div key={index} className={`flex flex-col flex-1 p-4 bg-white rounded-3xl`}>
                <div className="p-4">
                  <p className={`font-bold text-${color}-100 text-6xl mb-4`}>{item.icon}</p>
                  <div className="mb-4">
                    <CustomRichText data={item.title} tag="div" className="text-xl font-bold" />
                  </div>
                </div>
              </div>
            ))}
        </div>
        {btnText && (
          <div className="flex justify-center mt-8">
            <button
              onClick={openForm}
              className={`uppercase custom-gradient-${color}-btn rounded-full px-8 py-2.5 text-center text-md font-fixel font-bold text-white shadow-sm focus-visible:outline`}
            >
              {btnText}
            </button>
          </div>
        )}
      </div>
      {isFormOpen && (
        <ModalForm
          closeForm={closeForm}
          btnMeta={{
            tag: 'університет-Au-Pair',
          }}
          color={color}
        />
      )}
    </>
  );
}
